import { render, staticRenderFns } from "./DeliveryInput.vue?vue&type=template&id=af13ce20&scoped=true&"
import script from "./DeliveryInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af13ce20",
  null
  
)

export default component.exports